import { TJobTicket } from "./tickets";
import { TUser } from "./user";

export enum NotificationType {
  GENERAL = 'GENERAL',
  MENTION = 'MENTION',
  JOB_ASSIGNMENT = 'JOB_ASSIGNMENT',
  SERVICE_TICKET_ASSIGNMENT = 'SERVICE_TICKET_ASSIGNMENT',
  TASK_ASSIGNMENT = 'TASK_ASSIGNMENT',
  TASK_UPDATE = 'TASK_UPDATE',
  TASK_RED_FLAG = 'TASK_RED_FLAG',
  JOB_UPDATE = 'JOB_UPDATE',
  EMAIL = 'EMAIL',
}

export type TNotification = {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  userId: string | null;
  jobTicketId: string | null;
  title: string | null;
  content: string | null;
  isRead: boolean;
  notificationType: NotificationType;
  noteId: string | null;
  serviceTicketId: string | null;
  taskId: string | null;
  triggeredByUserId: string | null;
  metadata: Record<string, any> | null;
  user: TUser | null;
  jobTicket: TJobTicket | null;
  triggeredByUser: TUser | null;
};
